import moment from "moment-timezone";

import {SHIFT_ADMIN_ALL_FILTER_VALUE} from "../constants/ShiftAdminConstants";
import {formatDateAndTimeRange} from "./DateTimeRangeHelper";
import {
    calculateNetAmendmentDurationInMinutes,
    calculateTotalShiftDurationIncludingCheckInTimeInMinutes
} from "./ShiftHelper";

export default class ShiftAdminUtils {
    static mapShiftServiceKeycodes(shift) {
        return (shift?.bookableServiceTypes || [])
            .map((service) => service?.serviceType.keycode)
            .filter(Boolean);
    }

    static buildShiftTimeRanges(shifts, timezone) {
        return shifts
            .map((shift) => {
                const shiftStartTime = shift.performingFrom;
                const shiftEndTime = shift.to;

                return {
                    shiftStartTime,
                    label: formatDateAndTimeRange(shiftStartTime, shiftEndTime, timezone).time,
                };
            })
            .sort((left, right) => moment(left.shiftStartTime).valueOf() - moment(right.shiftStartTime).valueOf())
            .map((shiftTimeRange) => shiftTimeRange.label);
    }

    static buildAddPerformerMenuOptions(performers, filteredDayRows) {
        const visiblePerformerIds = new Set(filteredDayRows.map((row) => row.performerId));

        return performers
            .filter((performer) => !visiblePerformerIds.has(performer.id))
            .map((performer) => ({
                id: performer.id,
                fullName: `${performer.givenName} ${performer?.familyName}`,
            }))
            .sort((left, right) => left.fullName.localeCompare(right.fullName));
    }

    static doesRowMatchServiceFilter(row, selectedServiceFilter) {
        return selectedServiceFilter === SHIFT_ADMIN_ALL_FILTER_VALUE
            || (row?.services || []).includes(selectedServiceFilter);
    }

    static buildServiceFilteredRowMetrics(row, selectedServiceFilter, timezone) {
        const filteredShifts = (row?.shifts || []).filter((shift) => {
            if (selectedServiceFilter === SHIFT_ADMIN_ALL_FILTER_VALUE) {
                return true;
            }

            return ShiftAdminUtils.mapShiftServiceKeycodes(shift).includes(selectedServiceFilter);
        });

        const filteredShiftIds = new Set(filteredShifts.map((shift) => shift.id));
        const filteredAmendments = selectedServiceFilter === SHIFT_ADMIN_ALL_FILTER_VALUE
            ? (row?.amendments || [])
            : (row?.amendments || []).filter((amendment) => filteredShiftIds.has(amendment?.shift?.id));

        const filteredShiftMinutes = calculateTotalShiftDurationIncludingCheckInTimeInMinutes(filteredShifts);
        const filteredAmendmentMinutes = calculateNetAmendmentDurationInMinutes(filteredAmendments);
        const filteredServiceKeycodes = filteredShifts.flatMap((shift) => ShiftAdminUtils.mapShiftServiceKeycodes(shift));

        return {
            shifts: filteredShifts,
            services: [...new Set(filteredServiceKeycodes)],
            amendments: filteredAmendments,
            totalShiftCount: filteredShifts.length,
            amendmentCount: filteredAmendments.length,
            shiftTimeRanges: ShiftAdminUtils.buildShiftTimeRanges(filteredShifts, timezone),
            totalMinutesIncludingAmendments: filteredShiftMinutes + filteredAmendmentMinutes
        };
    }
}
